import {FetchManager} from "./FetchManager.js";
import {loadSolanaEnv} from './../../../env/index.js';
let _limiter: FetchManager | null = null;

export function getLimiter(rateLimiter?:any) {
  if (!_limiter) {
    const solanaEnv = loadSolanaEnv()
     _limiter = new FetchManager([solanaEnv.solanaMainnetRpcUrl],solanaEnv.fallbackRpcUrl);
  }
  return _limiter;
}
